import { create } from 'zustand'
import { trpcClient } from '../utils/trpc'

interface MaintenanceState {
	isInMaintenance: boolean
	message: string
	isChecking: boolean
	hasChecked: boolean
	lastChecked: Date | null
	checkMaintenanceStatus: () => Promise<void>
	startPolling: () => void
	stopPolling: () => void
	reset: () => void
}

let pollingInterval: ReturnType<typeof setInterval> | null = null
const POLL_INTERVAL = 2 * 60 * 1000 // 2 minutes

export const maintenanceStore = create<MaintenanceState>((set, get) => ({
	isInMaintenance: false,
	message: '',
	isChecking: false,
	hasChecked: false,
	lastChecked: null,

	checkMaintenanceStatus: async () => {
		set({ isChecking: true })
		try {
			const result = await trpcClient.client.organizations.checkMaintenanceStatus.query()
			set({
				isInMaintenance: result.inMaintenance,
				message: result.message || '',
				lastChecked: new Date(),
				hasChecked: true,
			})
		} catch (error) {
			console.error('Failed to check maintenance status:', error)
			// On error, mark as checked but don't block users
			set({ hasChecked: true })
		} finally {
			set({ isChecking: false })
		}
	},

	startPolling: () => {
		// Don't start if already polling
		if (pollingInterval) return

		// Start polling every 2 minutes
		pollingInterval = setInterval(() => {
			get().checkMaintenanceStatus()
		}, POLL_INTERVAL)
	},

	stopPolling: () => {
		if (pollingInterval) {
			clearInterval(pollingInterval)
			pollingInterval = null
		}
	},

	reset: () => {
		get().stopPolling()
		set({
			isInMaintenance: false,
			message: '',
			isChecking: false,
			hasChecked: false,
			lastChecked: null,
		})
	},
}))
